





































import ListItemStep from '@/components/Steps/ListItemStep.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PhaseRow from '@/components/Phases/PhaseRow.vue';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { Phase } from '@/interfaces/Phase';
import { Module } from '@/interfaces/Module';
import { Environment } from '@/interfaces/Environment';
import { Step } from '@/types';

@Component({
  components: {
    PhaseRow,
    ListItemStep
  }
})
export default class PhaseCard extends Vue {
  @Prop()
  cutoverplan?: Cutoverplan;

  @Prop()
  phase!: Phase;

  @Prop()
  selectedEnvironment!: number;

  selectedEnvironmentPhase = 0;

  @Watch('selectedEnvironment')
  watchSelectedEnvironment() {
    this.selectedEnvironmentPhase = this.selectedEnvironment;
  }

  mounted() {
    this.selectedEnvironmentPhase = this.selectedEnvironment;
  }

  removePhase(phase: Phase) {
    if (this.cutoverplan?.phases)
      this.cutoverplan.phases = this.cutoverplan?.phases.filter((p: any) => p.id !== phase.id);
  }

  adjustedModule?: Module;

  getOverwriteStep(step: Step): Step {
    if (!this.selectedEnvironment) return {} as Step;
    return step.environments[this.selectedEnvironment];
  }

  get selectedEnvironmentName() {
    return this.selectedEnvironmentPhase
      ? this.$store.state.all_environments.find(
          (environment: Environment) => environment.id === this.selectedEnvironmentPhase
        ).name
      : 'DEFAULT';
  }

  get phaseLanguage() {
    const preferredLanguage = this.phase.phaseLanguages?.find(
      (language: any) => language.languageId === this.$store.state.user.languageId
    );
    if (preferredLanguage) return preferredLanguage;
    return this.phase.phaseLanguages?.[0];
  }

  get name() {
    return this.phaseLanguage?.name;
  }
}
